export default __webpack_public_path__ + "7ae7e2a.png";